import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useNotificationIconStyles = makeStyles((theme) =>
  createStyles({
    menu: {
      marginTop: 32,

      [theme.breakpoints.down('md')]: {
        display: 'none'
      },
      '& .MuiMenu-paper': {
        maxHeight: 'none'
      }
    },

    list: {
      padding: 0
    },

    bottomNav: {
      borderTop: `1px solid ${theme.palette.text.disabled}`,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    },

    paper: {
      width: '100%',
      height: '663px'
    },

    tabPanel: {
      overflowY: 'auto',
      overflowX: 'hidden',
      height: '100%',
      maxHeight: 500,
      marginTop: 15
    },

    emptyMenu: {
      height: '100%',
      padding: 0
    },

    iconButton: {
      color: '#000',
      padding: 0,
      width: '32px',
      height: '32px',
      [theme.breakpoints.down('md')]: {
        display: 'none'
      }
    }
  })
)
